import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaAccessibleIcon } from "react-icons/fa";
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import { Buffer } from "buffer";
import { base64backendtoken } from "../HelperFx/datalinks";

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;
// //Console.log(username);

const ResetPwd = () => {
  const [errorsMsg, setErrorMsg] = useState("");
  const [open, setOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(formData);
    try {
      console.log("Now in here");
      const response = await axios.post(
        `${REACT_EXPRESS}/resetPwd`,
        formData,
        // {
        //   headers: {
        //     Authorization: `Basic ${token2}`,
        //   },
        // }
      );
      const { success, message } = response.data;
      if (success) {
        setSuccessMsg(
          "Check your email to get an otp! Redirecting to change Password",
        );

        setOpen(true); // Show snackbar

        // Delay navigation by 2 seconds (or whatever duration you want)
        setTimeout(() => {
          console.log("Redirecting to change password");
          navigate("/changepwd", { state: { email: formData.username } });
        }, 4000);
        // navigate('/signin', { state: { uname: formData.username, pwd: formData.password } });
      } else {
        setErrorMsg(message);
        handleClick();
      }
    } catch (error) {
      if (error.response && error.response.data.error) {
        console.log(error.response.data.error);
        setErrorMsg(error.response.data.error);
        handleClick();
      } else {
        setErrorMsg("Something went wrong");
        handleClick();
      }
    } finally {
      setLoading(false);
    }
  };
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Form onSubmit={handleSubmit} className="Login">
      <div className="login-head">
        <FaAccessibleIcon size={30} color="maroon" />
        <p>JMS Client</p>
      </div>
      <FormGroup>
        <Label for="exampleEmail">
          Provide your Registered email for a Password Reset
        </Label>
        <Input
          type="email"
          name="username"
          id="exampleEmail"
          placeholder="Enter your email"
          value={formData.username}
          onChange={handleChange}
        />
      </FormGroup>

      <div className="login-footer">
        <Button type="submit" className="login-btn">
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "Reset Password"
          )}
        </Button>
        <a href="/" className="forgot-password">
          Return to Login
        </a>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={
          <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
            {successMsg || errorsMsg}
          </pre>
        }
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Form>
  );
};

export default ResetPwd;
